import React, { useState, useEffect } from 'react'
import {
  GET_FILING_DETAILS,
  UPDATE_DATA_REQUEST_NAME,
  // UPDATE_DATA_REQUEST,
  UPDATE_DATA_REQUEST_CANCEL_SUB,
  UPDATE_DATA_REQUEST_PAUSE_SUB,
  UPDATE_DATA_REQUEST_RESUME_SUB,
} from 'requests'
// import PayrocGenericModal from '../Payroc/PayrocGenericModal'
import DetailsList from 'components/DetailsList/DetailsList'
import ActionButton, { ActionButtonGroup } from 'components/ActionButton/ActionButton'
import DocumentEditIcon from '@tecuity/sos-icons/react/document-edit'
import TrashIcon from '@tecuity/sos-icons/react/trash'
import VisibleIcon from '@tecuity/sos-icons/react/visible'
import PauseIcon from '@tecuity/sos-icons/react/pause'
import UnpauseIcon from '@tecuity/sos-icons/react/play'
// import CreditCardIcon from '@tecuity/sos-icons/react/credit-card-solid'
import SearchIcon from '@tecuity/sos-icons/react/search'
import Portal from 'components/Portal/Portal'
import { Modal, ConfirmDialog } from 'components/Modal/Modal'
import { TextInput } from '@tecuity/granite-ui/TextInput'
import { noop } from 'utilities'
import { history } from '../../store'

// const HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS = process.env.HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS || false

export default ({
  formDefinitionId,
  dataRequestId,
  dataRequestNum,
  nickname: initialNickname,
  onNicknameChange,
  onCanceled,
  canEdit,
  canPause,
  onPause,
  canUnpause,
  onUnpause,
  canEditPayment,
  canSearch,
  canCancel,
  onSearch,
}) => {
  const [details, setDetails] = useState([])
  const [loading, setLoading] = useState(true)
  const [editingNickname, setEditingNickname] = useState(false)
  const [nickname, setNickname] = useState(initialNickname)
  const [confirmingCancel, setConfirmingCancel] = useState(false)
  const [confirmingPause, setConfirmingPause] = useState(false)
  const [confirmingUnpause, setConfirmingUnpause] = useState(false)
  // const [canceled, setCanceled] = useState(false)
  const [error, setError] = useState('')
  const [showErrorMessages, setShowErrorMessages] = useState(false)
  // const [editingPaymentSource, setEditingPaymentSource] = useState(false)

  useEffect(() => {
    // setCanceled(false)
    setError('')
    setShowErrorMessages(false)
    getDetails()
  }, [dataRequestId])

  const getDetails = () => {
    setLoading(true)
    GET_FILING_DETAILS(
      'datarequests',
      dataRequestId,
      () => {},
      ({ DRAWER_DETAIL_LIST }) => {
        setDetails(DRAWER_DETAIL_LIST)
        setLoading(false)
      },
      (err) => {
        console.error(err)
        setLoading(false)
      }
    )
  }

  React.useEffect(() => {
    setNickname(initialNickname)
  }, [dataRequestId])

  const updateNickname = (closeModal) => {
    setError('')
    setShowErrorMessages(false)
    UPDATE_DATA_REQUEST_NAME(
      {
        DataRequestId: dataRequestId,
        NickNameChange: nickname,
      },
      () => {
        onNicknameChange(nickname)
        getDetails()
        closeModal()
      },
      (err) => {
        setLoading(false)
        setError(err.internalerror)
        setShowErrorMessages(true)
      }
    )
  }

  const cancelSubscription = () => {
    setError('')
    setShowErrorMessages(false)
    UPDATE_DATA_REQUEST_CANCEL_SUB(
      dataRequestId,
      () => {
        onCanceled()
        // setCanceled(true)
        getDetails()
      },
      (err) => {
        setLoading(false)
        setError(err.internalerror)
        setShowErrorMessages(true)
      }
    )
  }

  const pauseSubscription = () => {
    setError('')
    setShowErrorMessages(false)
    UPDATE_DATA_REQUEST_PAUSE_SUB(
      dataRequestId,
      () => {
        onPause()
        getDetails()
      },
      (err) => {
        setLoading(false)
        setError(err.internalerror)
        setShowErrorMessages(true)
      }
    )
  }

  const unpauseSubscription = () => {
    setError('')
    setShowErrorMessages(false)
    UPDATE_DATA_REQUEST_RESUME_SUB(
      dataRequestId,
      () => {
        onUnpause()
        getDetails()
      },
      (err) => {
        setLoading(false)
        setError(err.internalerror)
        setShowErrorMessages(true)
      }
    )
  }

  // const setPaymentMethod = (TOKEN) => {
  //   setEditingPaymentSource(false)
  //   setError('')
  //   setShowErrorMessages(false)
  //   UPDATE_DATA_REQUEST(
  //     {
  //       DataRequestFilingId: dataRequestId,
  //       TOKEN,
  //       action: 'UPDATE_PAYMENT',
  //     },
  //     () => {
  //       getDetails()
  //     },
  //     (err) => {
  //       setLoading(false)
  //       setError(err.internalerror)
  //       setShowErrorMessages(true)
  //     }
  //   )
  // }

  const toggleNicknameEdit = () => setEditingNickname((x) => !x)
  const toggleConfirmingCancel = () => setConfirmingCancel((x) => !x)
  const toggleConfirmingPause = () => setConfirmingPause((x) => !x)
  const toggleConfirmingUnpause = () => setConfirmingUnpause((x) => !x)
  const startReadOnlyWizard = () => {
    history.push(`/view/${formDefinitionId}/${dataRequestNum}`)
  }
  const startEditWizard = () => {
    history.push(`/correct/${formDefinitionId}/${dataRequestNum}`)
  }

  return (
    <div className={`dr-management-drawer ${loading ? 'loading' : ''}`}>
      <ActionButtonGroup>
        {canEdit ? (
          <ActionButton
            label="Edit Details"
            children={<DocumentEditIcon />}
            onClick={startEditWizard}
          />
        ) : null}
        {canSearch && <ActionButton label="Search" children={<SearchIcon />} onClick={onSearch} />}
        {canPause ? (
          <ActionButton
            label="Pause Subscription"
            children={<PauseIcon />}
            onClick={toggleConfirmingPause}
          />
        ) : null}
        {canUnpause ? (
          <ActionButton
            label="Unpause Subscription"
            children={<UnpauseIcon />}
            onClick={toggleConfirmingUnpause}
          />
        ) : null}
        {/* {canEditPayment ? (
          <ActionButton
            label="Select / Add Payment Method"
            children={<CreditCardIcon />}
            onClick={() => setEditingPaymentSource(true)}
          />
        ) : null} */}
      </ActionButtonGroup>
      {showErrorMessages ? (
        <p className="error-message" aria-live="polite">
          {error}
        </p>
      ) : null}
      <DetailsList details={details} />
      <ActionButtonGroup>
        <ActionButton
          label="View Details"
          children={<VisibleIcon />}
          onClick={startReadOnlyWizard}
        />
        <ActionButton
          label="Edit Nickname"
          children={<DocumentEditIcon />}
          onClick={toggleNicknameEdit}
        />
        {canCancel && (
          <ActionButton
            label="Cancel Subscription"
            children={<TrashIcon />}
            onClick={toggleConfirmingCancel}
          />
        )}
      </ActionButtonGroup>
      <Portal isOpened={editingNickname}>
        <Modal
          title="Edit Nickname"
          closeModal={toggleNicknameEdit}
          cancelButton
          saveButton
          autoHeight
          save={updateNickname}
        >
          <NicknameEditor onNicknameChange={setNickname} nickname={nickname} key={dataRequestId} />
        </Modal>
      </Portal>
      <Portal isOpened={confirmingCancel}>
        <ConfirmDialog
          closeModal={toggleConfirmingCancel}
          onModalClosed={noop}
          message="Are you sure you want to cancel this subscription? This cannot be undone."
          buttons={[
            { label: 'No', onClick: noop, className: 'btn-default' },
            {
              label: 'Yes',
              onClick: cancelSubscription,
              className: 'btn-danger',
            },
          ]}
          modalStyle={{ borderRadius: 3 }}
        />
      </Portal>
      <Portal isOpened={confirmingPause}>
        <ConfirmDialog
          closeModal={toggleConfirmingPause}
          onModalClosed={noop}
          message="Are you sure you want to pause this subscription?  Access to the search will be temporarily suspended while your pause is in effect."
          buttons={[
            { label: 'No', onClick: noop, className: 'btn-default' },
            {
              label: 'Yes',
              onClick: pauseSubscription,
              className: 'btn-danger',
            },
          ]}
          modalStyle={{ borderRadius: 3 }}
        />
      </Portal>
      <Portal isOpened={confirmingUnpause}>
        <ConfirmDialog
          closeModal={toggleConfirmingUnpause}
          onModalClosed={noop}
          message="Are you sure you want to unpause your subscription?  A monthly charge will automatically be applied to resume search services."
          buttons={[
            { label: 'No', onClick: noop, className: 'btn-default' },
            {
              label: 'Yes',
              onClick: unpauseSubscription,
              className: 'btn-danger',
            },
          ]}
          modalStyle={{ borderRadius: 3 }}
        />
      </Portal>
    </div>
  )
}

const NicknameEditor = ({ nickname, onNicknameChange }) => {
  return (
    <div className="wizard nickname-editor">
      <TextInput
        label="Set a new nickname"
        value={nickname}
        isFirst
        onChange={(e) => {
          onNicknameChange(e.target.value)
        }}
      />
    </div>
  )
}
